import CryptoJS from 'crypto-js';

// 这里是密钥
const keyHex = 'NT9FWl3ze1GJNqpo';
const ivHex = 'vL7iWTTV7RngvKkn';

// 解密  data：要加密解密的数据，AES_KEY：密钥，IV:偏移量
export const encrypt = (data, options) => {
    let {key: AES_KEY, iv: IV, mode} = (options && typeof options === 'object') ? options : {};
    const key = CryptoJS.enc.Utf8.parse(AES_KEY || keyHex);
    const iv = CryptoJS.enc.Utf8.parse(IV || ivHex);

    return CryptoJS.AES.encrypt(data, key, {
        iv,
        mode: CryptoJS.mode[mode ||'CBC'],
        padding: CryptoJS.pad.Pkcs7
    }).toString()
}

const encryptParams = (params, options) => {
    if (params?.cql_filter) {
        params = JSON.parse(JSON.stringify(params));
        params.CQL_FILTER_ENCRYPT = encrypt(encodeURI(params.cql_filter), options);

        delete params.cql_filter
    }

    return params
}

export default encryptParams;
